import axios from "axios";

const url = process.env.REACT_APP_BASE_API_URL;

export const siteFindAll = async () => {
    const headers = { "Content-Type": "application/json" };
    return await axios.get(url + "/v1/site/findall", { headers });
};

export const siteFindByUsuId = async () => {
    const headers = { "Content-Type": "application/json" };
    return await axios.get(url + "/v1/site/findbyusuid", { headers });
};


export const siteInsert = async (site) => {
    const headers = { "Content-Type": "application/json" };
    console.log(site);
    return await axios.post(url + "/v1/site/insert", site, { headers });
};

export const siteUpdate = async (site) => {
    const headers = { "Content-Type": "application/json" };
    return await axios.put(url + "/v1/site/update", site, { headers });
};

export const siteDelete = async (site) => {
    const headers = { "Content-Type": "application/json" };
    return await axios.delete(
        url + "/v1/site/delete",
        { data: site },
        { headers }
    );
};




